export default "__VITE_ASSET__sHVOqWj7__"